





























































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { POSBadge } from '@pos/interfaces/pos-v2';
import AccessControlBadgeForm from '@access-control/components/access-control-badge-form.vue';
import BpcAccessControlEventTable from '@access-control/components/tables/access-control-event-table.vue';
import PosSeeBadgeModal from '@pos/components/v2/pos-see-badge-modal.vue';
import BlockAccessControlBadgeModal from '@/app/modules/access-control/components/modals/block-access-control-badge-modal/block-access-control-badge-modal.vue';

@Component({
  name: 'bpc-pos-contact-details-badge-column',
  components: {
    'bpc-access-control-badge-form': AccessControlBadgeForm,
    'bpc-access-control-event-table': BpcAccessControlEventTable,
    'bpc-pos-see-badge-modal': PosSeeBadgeModal,
    'bpc-block-access-control-badge-modal': BlockAccessControlBadgeModal,
  },
})
export default class PosContactDetailsBadgeColumn extends Vue {
  // PROPS
  @Prop({ type: String, required: true }) readonly title: string;
  @Prop({ type: Number, required: true }) readonly contactId: number;
  @Prop({ type: Boolean, default: true }) readonly readOnlyTicket: boolean;

  // DATA
  public badges: POSBadge[] = [];
  public showBadgeInfo: boolean = false;
  public showBlockAccessControlBadgeModal = false;
  public badgeId: number = null;

  // COMPUTED
  // LIFECYCLE HOOKS

  // METHODS

  seeBadge(badgeId: number) {
    this.badgeId = badgeId;
    this.showBadgeInfo = true;
  }

  onShowBadgeClose() {
    this.showBadgeInfo = false;
  }

  onBadgeBlocked() {
    this.showBadgeInfo = false;
    this.onBlockAccessControlBadgeModal();
  }

  clickOnBlock(badgeId: number) {
    this.showBlockAccessControlBadgeModal = true;
    this.badgeId = badgeId;
  }

  onCloseBlockAccessControlBadgeModal() {
    this.showBlockAccessControlBadgeModal = false;
  }

  async onBlockAccessControlBadgeModal() {
    this.badges = await this.$posService.getBadgesOfContact(this.contactId);
    this.showBlockAccessControlBadgeModal = false;
  }

  async mounted() {
    try {
      this.badges = await this.$posService.getBadgesOfContact(this.contactId);
    } catch (e) {
      console.log(e);
    }
  }

  get lang(): string {
    return this.$store.getters['auth/userLang'];
  }

  // WATCHERS
}
